import type { PropsWithChildren } from 'react';

export type ShellProps = PropsWithChildren<{}>;

export function Shell({ children }: ShellProps) {
  return <div className="mx-auto max-w-4xl px-4">{children}</div>;
}
